import React from "react";
import "./SelfCoachingItem.css";
import { Link } from "react-router-dom";

export default function SelfCoachingItem(props) {
  return (
    <Link
      to={props.subset}
      className="selfCoachingItem horizontalBorder link centeredFlex responsiveWidth"
    >
      <img
        src="/images/arrowSquareRight.svg"
        alt="arrow icon"
        className="itemArrowIcon"
      />
      <div className="itemData">
        <div className="itemName centeredFlex">
          <h4>{props.name}</h4>
          <p>{props.nameInLatin}</p>
        </div>
        <div
          className="itemImg centeredFlex"
          style={{ backgroundColor: props.color }}
        >
          <img
            src={props.img}
            alt="sport"
            style={
              props.img === "/images/weight.png"
                ? { transform: "rotate(45deg)", width: "1.875rem" }
                : { transform: "rotate(0)", width: "1.5rem" }
            }
          />
        </div>
      </div>
    </Link>
  );
}
